import * as React from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteFilesApp = React.lazy(() => import("codat-files-ui/App"));

const Files = () => {
  return (
    <React.Suspense fallback={<PageLoadingSkeleton />}>
      <ErrorBoundary>
        <RemoteFilesApp />
      </ErrorBoundary>
    </React.Suspense>
  );
};

export default Files;
